import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrash} from "@fortawesome/free-solid-svg-icons";
import {Input, InputNumber} from "antd";
import NoPhotoImage from "../../assets/img/no-image.jpg";
import {useState, useEffect} from "react";
import ConsumerItem from "./ConsumerItem";

const CartItem = ({item, isMultiple, isValidate, onChangeItem, onChangeItemConsumers}) => {

    const [quantity, setQuantity] = useState(0);
    const [total, setTotal] = useState(0);
    const [consumers, setConsumers] = useState([]);

    useEffect(() => {
        setQuantity(item.quantity);
        setConsumers(item.consumers);
    }, [])

    useEffect(() => {
        setTotal(item.price * quantity);
    }, [quantity])

   /* useEffect(() => {
        onChangeItemConsumers(item.id, consumers);
    }, [consumers])*/

    const onChange = (qty) => {
        if (qty === null) {
            qty = 1;
        }
        qty = parseInt(qty);
        if (qty <= 1) {
            qty = 1;
        }
        setQuantity(parseInt(qty));
        onChangeItem(item.id, parseInt(qty));
    }
    const onValidate = (e) => {
        let qty = e.target.value;
        console.log('valid ' + qty);
        if (qty === null || qty === '') {
            qty = 1;
        }
        qty = parseInt(qty);
        if (qty <= 1) {
            qty = 1;
        }
        e.target.value = parseInt(qty);
        setQuantity(parseInt(qty));
        onChangeItem(item.id, parseInt(qty));
    }

    const onRemove = () => {
        onChangeItem(item.id, 0);
    }

    const onChangeConsumer = (index, consumer) => {
        let tConsumers = [];
        [...Array(quantity).keys()].forEach((i) => {
            if (consumers[i] !== undefined) {
                if (i === index) {
                    tConsumers.push(consumer);
                } else {
                    tConsumers.push(consumers[i]);
                }
            } else {
                if (i === index) {
                    tConsumers.push(consumer);
                } else {
                    tConsumers.push({surname: '', name: '', phone: '', email: ''});
                }
            }
        })
        setConsumers(tConsumers);
        onChangeItemConsumers(item.id, tConsumers);
    }

    return <div>
        <div className={'flex mob-flex-wrap items-center pb-4'}>
            <div className={'w-2/12 mob-w-full mob-m-4'}>
                <div className={'h-24 w-full rounded-lg object-cover object-center'} style={{
                    backgroundImage: 'url(' + (item.image ?? NoPhotoImage) + ')',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center center',
                }}></div>
            </div>
            <div className={'pl-4 mob-pl-0 ' + (isMultiple ? 'w-4/12 mob-w-full' : 'w-7/12 mob-w-full')}>
                <div className={'font-bold'}>Код: {item.code}</div>
                <div className={''}>{item.name}</div>
            </div>
            <div className={'w-2/12 mob-w-4/12 text-center ml-auto mob-ml-0 mob-mt-4 mob-font-bold'}>
                {item.price} руб.
            </div>
            {
                isMultiple && <div className={'w-1/12 mob-w-3/12 text-center mob-mt-4'}>
                Кол-во:
                    <InputNumber min={1} defaultValue={quantity} value={quantity} onKeyUp={onValidate} onChange={onChange} className={'w-full text-center'}/>
                </div>
            }
            {
                isMultiple && <div className={'w-2/12 mob-w-4/12 text-center font-bold mob-mt-4'}>
                    {total} руб.
                </div>
            }
            <div className={'w-1/12 text-center ml-auto mob-mt-4'}>
                <button className={'text-error'} onClick={onRemove}>
                    <FontAwesomeIcon icon={faTrash}/>
                </button>
            </div>
        </div>
        {
            isMultiple && quantity > 0 &&
            <div className={'w-full pb-4'}>
                {
                    [...Array(quantity).keys()].map(i =>
                        <ConsumerItem onChangeConsumer={onChangeConsumer} validate={isValidate} consumer={consumers[i] !== undefined ? consumers[i] : null} key={i} i={i} />
                    )
                }
            </div>
        }
    </div>
}

export default CartItem;
